import { Radio, Button, Typography, Form, Select, Input, Collapse, Grid } from "antd";
import styles from "./style.module.scss";
import React,{ useState,useEffect } from "react";
import { useSelector } from 'react-redux';
import PosService from "../../services/PosService";

const { Title, Text } = Typography;
const { Panel } = Collapse;
const { useBreakpoint } = Grid;

const CheckoutForm = ({cartItems,serverData,setOrderIssues}) => {
	const formRef = React.createRef();
	const [form] = Form.useForm();
	const [itemRelated, setItemRelated] = useState(true);
	const [solutions, setSolutions] = useState([]);
	const [issues, setIssues] = useState([]);
	const adminRestaurant = useSelector((state) => state.admin)
		const screens = useBreakpoint();



	useEffect(() => {
		(async () => {
		 
		   const orderIssues = await PosService.orderIssues(adminRestaurant)
		   setIssues(orderIssues?.orders?orderIssues?.orders:[])
		   
		})();
	  }, [adminRestaurant]);

	  const addIssue = async (values) => {
		const orderIssue = {
			menu_item_ids: values.menu_item_id,
			issue: values.issue,
			description: values.description,
	
			server_code: serverData?.restaurant_roles.find(item=>item.restaurant_id == adminRestaurant)?.employee_code,
			server_id: serverData?.id,
		  restaurant_id: adminRestaurant,
		   order_id: 99
		};
		setOrderIssues(orderIssue)
		// const posOrderIssues = await PosService.posOrderIssue(orderIssue)
		
	}

	return (
		<Collapse
  bordered={false}
  defaultActiveKey={[screens.md ?"issues" :""]}
  expandIconPosition="end"
  className="issue-collapse"
>
  <Panel
    key="issues"
    header={
      <div className={screens.md ? "":"mobile-issue-header"}>
        <Title level={3} className="theme-red" style={{ marginBottom: 0 }}>
          Issues
        </Title>
		{screens.md &&
        <Text type="secondary">
          Select issue and enter other details
        </Text>
	}
      </div>
    }
  >
    <Form
      form={form}
      ref={formRef}
      layout="vertical"
      onFinish={addIssue}
    >
      {itemRelated ? (
        <>
          <Form.Item label="Select item" name="menu_item_id">
            <Select placeholder="Select item here" mode="multiple">
              {cartItems?.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Issues" name="issue">
            <Input placeholder="Enter Issues here" />
          </Form.Item>

          <Form.Item label="Description" name="description">
            <Input.TextArea placeholder="Add notes here" />
          </Form.Item>
        </>
      ) : (
        <>
          <Form.Item label="Add notes">
            <Input.TextArea placeholder="Add notes here" />
          </Form.Item>

          <Form.Item label="Enter discount code">
            <Input placeholder="Enter discount code here" />
          </Form.Item>
        </>
      )}

      <Form.Item style={{ paddingTop: 50, textAlign: "center" }}>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: 180, height: 45, fontSize: 16 }}
        >
          Save
        </Button>
      </Form.Item>
    </Form>
  </Panel>
</Collapse>
	);
};

export default CheckoutForm;
